import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { getCurrentFolderId, getGallectionById, getGrusername } from '../selectors';
import { call, put, select } from 'redux-saga/effects';
import get from 'lodash/get';
import { getGallectionType } from '../helpers';
import { requestNapi } from '@wix/da-http-client';
import { normalizeGallection } from '../../redux/normalizr/helpers';
import { putEntities } from '../../redux/entities/actions';
import { dollarsToPoints } from '../../utils/points';
function* convertGalleryHandler() {
    const currentFolderId = yield select(getCurrentFolderId);
    const gallection = yield select(getGallectionById, currentFolderId);
    const username = yield select(getGrusername);
    if (!gallection) {
        return;
    }
    const defaultPriceInDollars = 10;
    var _getGallectionType;
    const params = {
        username,
        type: (_getGallectionType = getGallectionType(gallection)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'gallery',
        folderid: gallection.folderId,
        name: gallection.name,
        premium_type: 'paid',
        cover_deviationid: gallection.type === 'stash' ? undefined : get(gallection, 'thumb.deviationId'),
        points_price: dollarsToPoints(defaultPriceInDollars)
    };
    if (gallection.richDescription) {
        params.editorRaw = gallection.richDescription.html.markup;
    }
    const result = yield call(requestNapi, {
        method: 'post',
        url: 'gallection/folders/update',
        data: params
    }, undefined);
    // new gallery converted to premium, reload page
    if (result) {
        const updatedGallection = _object_spread_props(_object_spread({}, gallection), {
            premiumFolderData: {
                pointsPrice: params.points_price,
                dollarPrice: defaultPriceInDollars,
                numSubscribers: 0,
                type: params.premium_type,
                hasAccess: true
            }
        });
        const entities = normalizeGallection(updatedGallection);
        yield put(putEntities({
            entities
        }));
    }
}
export default convertGalleryHandler;

//# sourceMappingURL=convertGallery.js.map